import { useEntityAPI } from '../../../redux/entity-api.hook';
import { documentTypesAPI } from '../redux/document-type.slice';

export function useDocumentTypes() {
  return useEntityAPI(documentTypesAPI);
}
